const API_BASE = '/api/v1/forum'

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

// JSONAPI::Serializer wraps data as { id, type, attributes: { ... } }.
// This flattens it to { id, ...attributes } for easier JS consumption.
export function normalize(data) {
  if (data == null) return data
  if (Array.isArray(data)) return data.map(normalize)
  if (typeof data === 'object' && 'attributes' in data && 'type' in data) {
    return { id: data.id, ...data.attributes }
  }
  return data
}

async function request(path, options = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': csrfToken(),
    ...options.headers
  }

  const response = await fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers
  })

  if (response.status === 401) {
    window.location.href = '/login'
    return null
  }

  if (response.status === 204) return null

  const data = await response.json()

  if (!response.ok) {
    const details = Array.isArray(data.errors) && data.errors.length > 0
      ? data.errors.join(', ')
      : data.error || `HTTP ${response.status}`
    const error = new Error(details)
    error.status = response.status
    error.body = data
    throw error
  }

  return data
}

export function get(path, params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== '')
  ).toString()
  const fullPath = query ? `${path}?${query}` : path
  return request(fullPath)
}

export function post(path, body = {}) {
  return request(path, { method: 'POST', body: JSON.stringify(body) })
}

export function put(path, body = {}) {
  return request(path, { method: 'PUT', body: JSON.stringify(body) })
}

export function del(path) {
  return request(path, { method: 'DELETE' })
}
